import {AxiosError} from 'axios';
import axiosClient from '../axiosClient';
import {GET_LIST_SUBJECTS_URL} from '../../constants/apiUrls';
import {PaginatedData} from '../../models/List';
import {useCustomMutation} from '../utils/useCustomMutation';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Request & Response Model
// =============================================================================

export interface GetListSubjectRequestData {
  page: number;
  size: number;
  uuid: string;
}

export interface SubjectModel {
  examDate: string;
  examLevel: string;
  examSeries: string;
  modeOfAssessment: string;
  paperUuid: string;
  selected: boolean;
  subject: string;
  subjectUuid: string;
}

// =============================================================================
// Query
// =============================================================================
interface Input {
  onSuccess?: (data: PaginatedData<SubjectModel>) => void;
  onError?: (data: AxiosError<GenericErrorResponse>) => void;
}

export const useGetSubjectList = ({onSuccess, onError}: Input) => {
  const getSubjectList = async (payload: GetListSubjectRequestData) => {
    const res = await axiosClient.get<PaginatedData<SubjectModel>>(
        GET_LIST_SUBJECTS_URL(payload.uuid, payload.page, payload.size)
    );
    return res.data;
  };

  return useCustomMutation(getSubjectList, {
    onSuccess,
    onError,
  });
};
